import _ from 'underscore';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Select } from '@bingads-webui-react/primitive';
import { Alert } from '@bingads-webui-react/alert';
import { OccasionI18nKeys } from '../i18n/occasion-i18n-keys';

const OCCASION_HINT = _TL_('After choosing an occasion from the list, be sure to set your promotion extension’s <b>Start date</b> and <b>End date</b> below <b>Selected days and hours</b>. Otherwise, the promotion extension will serve every year during the occasion’s predefined date range. Please note that your promotion extension will show continuously if you set the occasion to <b>None</b> and don’t enter the <b>Start date</b> and <b>End date</b>. <a class="HelpTopic" query="60046" href="#">Learn more</a>');

export function OccasionSelect({
  className, id, onChange, value: selected, i18n,
}) {
  const [selectedOccasion, setSelectedOccasion] = useState(selected);

  return (
    <React.Fragment>
      <Select
        id={id}
        className={className}
        value={selectedOccasion}
        onChange={(event) => {
          const occasion = event.target.value;
          setSelectedOccasion(occasion);
          onChange(occasion);
        }}
      >
        {_.pairs(OccasionI18nKeys).map(([key, value]) =>
          (
            <option key={key} value={key}>
              {i18n.getString(value)}
            </option>
          ))}
      </Select>
      <Alert
        message={i18n.getString(OCCASION_HINT)}
        level="Info"
        icon={(<div className="alert-image" />)}
        dismissible={false}
      />
    </React.Fragment>
  );
}

OccasionSelect.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
};

OccasionSelect.defaultProps = {
  id: undefined,
  value: 'None',
};
